import { useDroppable } from "@dnd-kit/core";
import React, { Fragment } from "react";
import FormDroppableFunctions from "../FormBuilder/FormCreation/FormDroppable/FormDroppableFunctions";
import { MdDragIndicator } from "react-icons/md";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import trans from "../../utils";

function SortableGroupItem({
	item,
	index,
	getInputType,
	activeInput,
	setActiveInput,
	setDroppedItems,
	active,
	setActive,
	groupKey,
	allData,
	submitAttempt,
}) {
	const validationColor = () => {
		if (
			(submitAttempt &&
				item?.dropdownOptions?.data &&
				Array.isArray(item.dropdownOptions.data) &&
				item.dropdownOptions.data.some(
					(opt) => opt.label === "" && opt.value === ""
				)) ||
			(submitAttempt &&
				item?.radioOptions &&
				Array.isArray(item.radioOptions) &&
				item.radioOptions.some(
					(opt) => opt.label === "" && opt.value === ""
				)) ||
			(submitAttempt &&
				item?.name === "Image" &&
				(item?.imgPath === null || item?.imgPath === "")) ||
			(submitAttempt &&
				item?.name === "Link" &&
				(item?.hyperLink === null || item?.hyperLink === ""))
		) {
			return "red";
		}
		return "#ccc";
	};

	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({
    id: `task-item-${groupKey}-${item.key}`,
    data: {
        type: "group-field",
        groupKey,
        itemKey: item.key,
    },
});
	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		padding: "6px",
		marginBottom: "4px",
		border: "1px solid #ccc",
		borderRadius: "6px",
		backgroundColor: "#fff",
		opacity: isDragging ? 0.4 : 1,
		filter: isDragging ? "grayscale(100%)" : "none",
		cursor: "pointer",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		flexGrow: 1,
		borderColor: validationColor(),
	};

	return (
		<div
			ref={setNodeRef}
			style={style}
			onClick={async (e) => {
				e.stopPropagation();
				await setActiveInput(item?.key);
				setActive(true);
			}}
			className={
				activeInput === item?.key && active
					? "task-form-inputs-active "
					: "task-form-inputs "
			}
		>
			<div
				{...attributes}
				{...listeners}
				style={{ cursor: "grab", paddingRight: "8px" }}
				onClick={(e) => e.stopPropagation()}
				onMouseDown={(e) => {
					e.stopPropagation();
					setActiveInput(item.key);
					setActive(true);
				}}
				onTouchStart={(e) => {
					e.stopPropagation();
					setActiveInput(item.key);
					setActive(true);
				}}
			>
				<MdDragIndicator size={20} />
			</div>
			<div style={{ flexGrow: 1 }}>{getInputType(item)}</div>
			{activeInput === item?.key && active && (
				<FormDroppableFunctions
					item={item}
					allData={allData}
					setDroppedItems={setDroppedItems}
					repeatingGroup={true}
					groupKey={groupKey}
					activeInput={activeInput}
				/>
			)}
		</div>
	);
}

export default function RepeatingGroupBuilder({
	handleDragEnd,
	getInputType,
	fields,
	setActiveInput,
	activeInput,
	css,
	active,
	groupKey,
	setDroppedItems,
	setActive,
	dropIndicatorIndex,
	dragDirection,
	childLevel,
	submitAttempt,
	item,
	addForm,
}) {
	const { setNodeRef, isOver } = useDroppable({
		id: `task-droppable-${groupKey}`,
		data: {
			type: "repeating-group",
			groupKey,
		},
	});

	const groupConfig = item?.groupConfig || {};

	return (
		<div
			ref={setNodeRef}
			style={{
				border: "1px dashed gray",
				backgroundColor: isOver ? "#0f69361f" : "#fafafa",
				padding: "20px",
				width: "100%",
				display: "flex",
				flexDirection: "column",
				...css,
			}}
		>
			<div style={{ marginBottom: 8, fontWeight: 600 }}>
				{groupConfig.groupTitle || trans("Repeating Group")}
			</div>
			{fields?.length === 0 ? (
				<h4
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: "100%",
					}}
				>
					{trans("Drop child fields here")}
				</h4>
			) : (
				fields.map((child, index) => (
					<Fragment key={child.key}>
						{dropIndicatorIndex === index &&
							dragDirection === "up" &&
							childLevel && (
								<div
									style={{
										height: "2px",
										backgroundColor: "#72777253",
										margin: "2px 0",
										width: "100%",
										zIndex: "99999",
									}}
								/>
							)}
						<SortableGroupItem
							item={child}
							index={index}
							getInputType={getInputType}
							activeInput={activeInput}
							setActiveInput={setActiveInput}
							setDroppedItems={setDroppedItems}
							active={active}
							setActive={setActive}
							groupKey={groupKey}
							allData={fields}
							submitAttempt={submitAttempt}
						/>
						{dropIndicatorIndex === index &&
							dragDirection === "down" &&
							childLevel && (
								<div
									style={{
										height: "2px",
										backgroundColor: "#72777253",
										margin: "2px 0",
										width: "100%",
										zIndex: "99999",
									}}
								/>
							)}
						</Fragment>
					))
				)}
		</div>
	);
}
